import styled from 'styled-components'

const MenuItem = styled.button`
  border: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.light1};
  text-decoration: none;
  color: ${({ theme, show }) => (show ? theme.colors.active1 : 'black')};
  font-size: 19px;
  transition: 300ms ease all;
  letter-spacing: 0.02rem;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
  &:focus {
    outline: none;
  }
  padding: 0;
  > a {
    border: none;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.light1};
    text-decoration: none;
    color: ${(props) => props.theme.colors.dark1};
    font-weight: 600;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
      'Segoe UI Symbol' !important;
    transition: 300ms ease all;
    letter-spacing: 0.02rem;
    &:hover {
      color: ${({ theme }) => theme.colors.active1};
    }
  }

  &:hover {
    color: ${({ theme }) => theme.colors.active1};
  }

  @media ${({ theme }) => theme.breakpoints.tablet} {
    font-size: 21px;
  }

  .active-link {
    color: ${({ theme }) => theme.colors.active1};
  }
`

export default MenuItem
